<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import pdf from 'vue-pdf';
import DatePicker from "vue2-datepicker";
import Multiselect from 'vue-multiselect';
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, pdf, Multiselect, DatePicker },
    data() {
        return {
            title: "Revisión de Gastos",
            items: [
                {
                text: "Gastos",
                href: "/web/reembolsos/ver_reembolsos"
                },
                {
                text: "Revisión de Gastos",
                active: true
                }
            ],
            reembolsos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            direccion:'',
            extension:'',
            archivoDisponible: true,
            archivoMensaje: '',
            valor_editar:{
                evento:'',
                tipo:'',
                monto:'$0',
                imagen:[],
                fecha:'',
                colegio:''
            },
            tipos:['Transporte local/Nacional','Transporte Uber','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Viajes Aereos'],
            imagenminiatura:'',
            colegiosFiltrados:[],
            eventoscolegiosFiltrados:[],
            eventosFiltrados:[],
            archivoPreview: '',
            tipoArchivo: '',
            todoseventos:[],
            eventos:[],
            colegios:[],
            cambiar:false,
            isLoadingReembolsos: false,
        };
    },
    computed:{
        puedeAprobarGastos() {
            return !!this.user && (this.user.rol === 'SuperAdmin' || this.user.rol === 'Admin');
        },
        rows() {
            return this.filteredData.length;
        },
        filteredData() {
            const filtro = (this.filtro || '').toLowerCase().trim();
            if (!filtro) {
                return this.reembolsos;
            }

            // Filtrar por codigo de evento
            return this.reembolsos.filter((item) => {
                const codigo = (item.codigo || '').toLowerCase();
                return codigo.includes(filtro);
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalPages() {
            return Math.ceil(this.filteredData.length / this.perPage);
        },
    },
    methods:{
        filtrarReembolsosPorRol(eventos) {
            const eventosConGastos = (eventos || []).filter((evento) => evento.boolean == true);

            if (!this.user || !this.user.rol) {
                return eventosConGastos;
            }

            if (this.user.rol == 'SuperAdmin' || this.user.rol == 'Admin' || this.user.rol == 'Gastos') {
                return eventosConGastos;
            }

            if (this.user.rol == 'Supervisor') {
                return eventosConGastos;
            }

            if (this.user.rol == 'Coordinador') {
                return eventosConGastos.filter((evento) => {
                    const coincidePorId = Number(evento.user_id) === Number(this.user.id);
                    const coincidePorNombre = (evento.coordinador_evento || '') === (this.user.name || '');
                    return coincidePorId || coincidePorNombre;
                });
            }

            return [];
        },
        cargarReembolsos() {
            this.isLoadingReembolsos = true;
            axios.get('/api/get_gastos')
                .then(res => {
                    this.reembolsos = this.filtrarReembolsosPorRol(res.data.eventos);
                })
                .catch(() => {
                    this.reembolsos = [];
                    this.msg('error', 'No se pudieron cargar los gastos');
                })
                .finally(() => {
                    this.isLoadingReembolsos = false;
                });
        },
        resetArchivoPreview() {
            this.direccion = '';
            this.extension = '';
            this.archivoDisponible = true;
            this.archivoMensaje = '';
        },
        getEncodedFileUrl(url) {
            if (!url) {
                return '';
            }

            return url
                .split('/')
                .map((segment, index) => {
                    if (index === 0 && segment === '') {
                        return '';
                    }

                    return encodeURIComponent(segment);
                })
                .join('/');
        },
        async prepareFilePreview(fileUrl) {
            this.resetArchivoPreview();

            if (!fileUrl) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El gasto no tiene comprobante asociado.';
                return;
            }

            const extension = fileUrl.split('.').pop().toLowerCase();
            const encodedUrl = this.getEncodedFileUrl(fileUrl);

            this.extension = extension === 'pdf' ? 'pdf' : '';

            try {
                await axios.head(encodedUrl);
                this.direccion = encodedUrl;
            } catch (error) {
                this.archivoDisponible = false;
                this.archivoMensaje = 'El comprobante no está disponible en el servidor. Es necesario volver a cargar el archivo.';
            }
        },
        ver_mas(item){
            this.$set(item, 'boton', item.boton === 'Ver más' ? 'Ver menos' : 'Ver más');
        },
        totalGastosEvento(item) {
            if (!item || !Array.isArray(item.gastos) || item.gastos.length === 0) {
                return this.format_Valor_variable(0);
            }
            const total = item.gastos.reduce((acumulado, gasto) => {
                const monto = parseInt(String(gasto && gasto.monto ? gasto.monto : 0).replace(/[^0-9]/g, ''), 10) || 0;
                return acumulado + monto;
            }, 0);
            return this.format_Valor_variable(total);
        },
        async ver_comprobante(item){
            await this.prepareFilePreview(item.imagen_url);
            this.$refs['modal-imagen'].show();
        },
        aprobar_gasto(item){
            if (!this.puedeAprobarGastos) {
                return;
            }

            let formData = new FormData();
            formData.append('gasto_id', item.id);
            formData.append('status', item.status);
            axios.post('/api/seleccionar_gasto',formData).then(response => {
                this.msg('success','Aprobado')
            }).catch(() => {
                this.msg('error', 'No autorizado para aprobar gastos');
            });
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        async modal_editar(item){
            this.valor_editar.id = item.id;
            this.valor_editar.fecha = item.fecha;
            this.valor_editar.evento = this.todoseventos.filter(evento => evento.id==item.evento_id);
            this.valor_editar.colegio = this.colegios.filter(colegio => colegio.rbd==this.valor_editar.evento[0].rbd_colegio);
            this.valor_editar.monto = item.monto;
            this.valor_editar.tipo = item.tipo_gasto;
            await this.prepareFilePreview(item.imagen_url);
            this.$refs['modal-editar'].show();
        },
        filtro_colegios() {
            if (!this.valor_editar.fecha) return;
            // Filtrar eventos por la fecha seleccionada
            this.eventoscolegiosFiltrados = this.eventos.filter(
                (evento) => moment(evento.fecha_inicio).format('YYYY-MM-DD') === this.valor_editar.fecha
            );
            // Extraer RBD únicos y asegurarnos de que sean cadenas para evitar problemas de comparación
            const rbdUnicos = [...new Set(this.eventoscolegiosFiltrados.map(evento => String(evento.rbd_colegio).trim()))];
            // Filtrar colegios con los RBD obtenidos
            this.colegiosFiltrados = this.colegios.filter(colegio =>
                rbdUnicos.includes(String(colegio.rbd).trim())
            );
        },
        filtro_eventos(){
            this.eventosFiltrados = this.eventoscolegiosFiltrados.filter(
                (evento) => evento.rbd_colegio == this.valor_editar.colegio.rbd
            );
        },
        disabledBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today ;
        },
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        labelColegio(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        obtenerImagen(e){
            let file = e.target.files[0];
            if (!file) return;
            this.valor_editar.imagen = file;
            this.cargarImagen(file);
        },
        cargarImagen(file){
            let reader = new FileReader();
            // Verificar el tipo de archivo
            if (file.type.includes("image")) {
                this.tipoArchivo = "imagen";
            } else if (file.type.includes("pdf")) {
                this.tipoArchivo = "pdf";
            } else {
                this.tipoArchivo = "";
                return;
            }
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        format_Valor(){
            this.valor_editar.monto=this.format_Valor_variable(this.valor_editar.monto);
        },
        formatMontoMiles(val) {
            const monto = parseInt(String(val || 0).replace(/[^0-9]/g, ''), 10) || 0;
            return monto.toLocaleString('es-CL');
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        btn_cambiar(){
            this.cambiar=!this.cambiar;
        },
        editar(){
            let formData = new FormData();
            formData.append('id', this.valor_editar.id);
            formData.append('tipo', this.valor_editar.tipo);
            formData.append('monto', this.valor_editar.monto);
            formData.append('imagen', this.valor_editar.imagen);
            axios.post('/api/editar_gastos',formData).then(res=>{
                if(res.data.estado){
                    this.valor_editar.fecha='';
                    this.valor_editar.colegio='';
                    this.valor_editar.evento='';
                    this.valor_editar.tipo='';
                    this.valor_editar.monto='$0';
                    this.valor_editar.imagen=[];
                    this.imagenminiatura='';
                    this.tipoArchivo='';
                    this.msg('success','Gasto editado correctamente');
                    this.cargarReembolsos();
                }else{
                    this.msg('error','Gasto No editado');
                }
            });
        },
        eliminar(item){
            let formData = new FormData();
            formData.append('gasto_id', item.id);
            Swal.fire({
                title: "¿Está seguro que desea eliminar este gasto?",
                text: "¡No podrás revertir esto! ",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Si, estoy seguro",
                cancelButtonText: "Cancelar"
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('/api/eliminar_gastos',formData).then(response => {
                        if (response.data.estado) {
                            Swal.fire({
                                title: "Eliminado",
                                text: "La información ha sido borrada",
                                icon: "success",
                                showConfirmButton: false,
                                timer: 1000
                            });
                            this.cargarReembolsos();
                        }
                    });
                }
            });
        }
    },
    created(){
        this.cargarReembolsos();
        axios.get('/api/get_eventos').then(res=>{
            this.todoseventos=res.data.eventos
            this.eventos = res.data.eventos.filter(evento => new Date(evento.fecha_inicio) <= new Date());
        });
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.colegios = response.data.colegios;
            }
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-receipt font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Revisión de Gastos</h5>
                            <small class="text-white" style="opacity:.8;">Aprueba o rechaza gastos asociados a eventos</small>
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Cargando -->
                        <div v-if="isLoadingReembolsos" class="text-center py-5" style="border:1px dashed #dee2e6;border-radius:8px;">
                            <b-spinner variant="primary" style="width:2.5rem;height:2.5rem;"></b-spinner>
                            <p class="mt-3 mb-0" style="color:#252C5F;font-weight:600;">Cargando gastos...</p>
                            <small class="text-muted">Estamos trayendo la información, por favor espera.</small>
                        </div>

                        <!-- Sin datos -->
                        <div v-else-if="filteredData.length === 0" class="text-center py-5" style="border:1px dashed #dee2e6;border-radius:8px;">
                            <i class="bx bx-receipt font-size-48 d-block mb-2" style="color:#CB9700;"></i>
                            <p class="text-muted mb-0">No hay gastos registrados para revisar</p>
                        </div>

                        <template v-else>
                            <!-- Filtros -->
                            <div class="row align-items-center mb-3">
                                <div class="col-md-6">
                                    <label class="d-inline-flex align-items-center mb-0" style="color:#252C5F;font-size:.85rem;">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;registros
                                    </label>
                                </div>
                                <div class="col-md-6 text-md-right">
                                    <b-form-input v-model="filtro" type="search" placeholder="Buscar por código..."
                                        class="form-control form-control-sm d-inline-block" style="max-width:220px;"></b-form-input>
                                </div>
                            </div>

                            <!-- Tabla principal -->
                            <div class="table-responsive">
                                <table class="table table-hover mb-0">
                                    <thead style="background:#252C5F;color:#fff;">
                                        <tr>
                                            <th class="font-weight-normal py-2 pl-3" style="width:5%">Nº</th>
                                            <th class="font-weight-normal py-2" style="width:15%">Código Evento</th>
                                            <th class="font-weight-normal py-2" style="width:20%">Coordinador</th>
                                            <th class="font-weight-normal py-2" style="width:12%">Total</th>
                                            <th class="font-weight-normal py-2" style="width:10%">Detalle</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(item, index) in paginatedData">
                                            <tr :key="'row-'+( item.id || index)">
                                                <td class="pl-3">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
                                                <td><code>{{ item.codigo }}</code></td>
                                                <td>{{ item.coordinador_evento }}</td>
                                                <td>
                                                    <span class="badge" style="background:#61B7E4;color:#fff;font-size:.8rem;padding:4px 8px;">{{ totalGastosEvento(item) }}</span>
                                                </td>
                                                <td>
                                                    <button class="btn-ugm-white" v-b-toggle="'accordion-'+item.id" @click="ver_mas(item)" style="font-size:.8rem;padding:4px 12px;">
                                                        <i :class="item.boton === 'Ver menos' ? 'bx bx-chevron-up' : 'bx bx-chevron-down'" class="mr-1"></i>
                                                        {{ item.boton || 'Ver más' }}
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr :key="'collapse-'+(item.id || index)">
                                                <td colspan="5" class="p-0 border-0">
                                                    <b-collapse :id="'accordion-'+item.id" accordion="my-accordion" role="tabpanel">
                                                        <div class="p-3" style="background:#f8f9fa;">
                                                            <div class="d-flex align-items-center mb-2">
                                                                <div style="width:4px;height:14px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                                                <span class="font-weight-bold" style="color:#252C5F;font-size:.85rem;">Gastos del evento</span>
                                                            </div>
                                                            <div class="table-responsive">
                                                                <table class="table table-sm bg-white mb-0" style="border-radius:6px;overflow:hidden;">
                                                                    <thead style="background:#61B7E4;color:#fff;">
                                                                        <tr>
                                                                            <th class="font-weight-normal py-1 pl-3" style="width:5%">Nº</th>
                                                                            <th class="font-weight-normal py-1" style="width:5%">✓</th>
                                                                            <th class="font-weight-normal py-1">Tipo Gasto</th>
                                                                            <th class="font-weight-normal py-1">Monto</th>
                                                                            <th class="font-weight-normal py-1">Comprobante</th>
                                                                            <th class="font-weight-normal py-1">Acciones</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item2, index2) in item.gastos" :key="index2">
                                                                            <td class="pl-3">{{ index2 + 1 }}</td>
                                                                            <td>
                                                                                <b-form-checkbox
                                                                                    :id="'checkbox-'+index2+'-'+index"
                                                                                    v-model="item2.status"
                                                                                    value="1"
                                                                                    unchecked-value="0"
                                                                                    :disabled="!puedeAprobarGastos"
                                                                                    :title="puedeAprobarGastos ? 'Aprobar o quitar aprobación' : 'Solo Admin o SuperAdmin pueden aprobar gastos'"
                                                                                    @change="aprobar_gasto(item2)">
                                                                                </b-form-checkbox>
                                                                            </td>
                                                                            <td>{{ item2.tipo_gasto }}</td>
                                                                            <td>{{ formatMontoMiles(item2.monto) }}</td>
                                                                            <td>
                                                                                <button class="btn-ugm-white" style="font-size:.75rem;padding:3px 10px;" @click="ver_comprobante(item2)">
                                                                                    <i class="bx bx-file mr-1"></i> Ver
                                                                                </button>
                                                                            </td>
                                                                            <td>
                                                                                <button class="btn-ugm-white mr-1" style="font-size:.75rem;padding:3px 10px;" @click="modal_editar(item2)">
                                                                                    <i class="bx bx-edit"></i>
                                                                                </button>
                                                                                <button class="btn-ugm-danger" style="font-size:.75rem;padding:3px 10px;" @click="eliminar(item2)">
                                                                                    <i class="bx bx-trash"></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Paginación -->
                            <div class="row mt-3">
                                <div class="col text-right">
                                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" class="mb-0 justify-content-end"></b-pagination>
                                </div>
                            </div>
                        </template>

                        <!-- Modal comprobante -->
                        <b-modal ref="modal-imagen" title="Comprobante de Gasto" ok-only ok-title="Cerrar">
                            <div v-if="!archivoDisponible" class="alert alert-warning mb-0">{{ archivoMensaje }}</div>
                            <pdf :src="direccion" v-else-if="extension=='pdf'"></pdf>
                            <img :src="direccion" width="100%" v-else>
                        </b-modal>

                        <!-- Modal editar -->
                        <b-modal ref="modal-editar" title="Editar Gasto" ok-title="Guardar" cancel-title="Cancelar" @ok="editar">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="font-weight-semibold" style="color:#252C5F;">Fecha</label>
                                        <date-picker v-model="valor_editar.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY"
                                            :first-day-of-week="2" lang="es" :disabled-date="disabledBeforeToday"
                                            @change="filtro_colegios" disabled style="width:100%;"></date-picker>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="font-weight-semibold" style="color:#252C5F;">Tipo de gasto</label>
                                        <multiselect v-model="valor_editar.tipo" :options="tipos"
                                            placeholder="Seleccionar tipo" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover">
                                            <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                            <template v-slot:noResult><span class="text-muted">Sin coincidencias</span></template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="font-weight-semibold" style="color:#252C5F;">Monto del Gasto</label>
                                        <b-form-input v-model="valor_editar.monto" @input="format_Valor"></b-form-input>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <b-button :variant="cambiar ? 'secondary' : 'primary'" @click="btn_cambiar" size="sm">
                                        {{ cambiar ? 'No cambiar documento' : 'Cambiar Documento' }}
                                    </b-button>
                                    <div class="mt-2" v-if="!cambiar">
                                        <div v-if="!archivoDisponible" class="alert alert-warning mb-0">{{ archivoMensaje }}</div>
                                        <pdf :src="direccion" v-else-if="extension=='pdf'"></pdf>
                                        <img :src="direccion" width="100%" v-else>
                                    </div>
                                    <div class="row mt-2" v-else>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="font-weight-semibold" style="color:#252C5F;">Nuevo documento</label>
                                                <b-form-file v-model="valor_editar.imagen"
                                                    accept="image/png, image/jpeg, image/jpg, application/pdf"
                                                    placeholder="Elegir Archivo"
                                                    drop-placeholder="Arrastra el archivo aquí..."
                                                    @change="obtenerImagen" browse-text="Examinar"></b-form-file>
                                            </div>
                                        </div>
                                        <div class="col-md-12 text-center">
                                            <figure v-if="tipoArchivo === 'imagen'">
                                                <img :src="imagenminiatura" height="200" alt="Preview" style="border-radius:6px;">
                                            </figure>
                                            <div v-if="tipoArchivo === 'pdf'">
                                                <pdf :src="imagenminiatura"></pdf>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.btn-ugm-white {
    background: #fff !important;
    color: #252C5F !important;
    border: 1px solid #252C5F !important;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: .8rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-white:hover { opacity: .8; }
.btn-ugm-danger {
    background: #dc3545 !important;
    color: #fff !important;
    border: 1px solid #dc3545 !important;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: .8rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-danger:hover { opacity: .85; }
</style>
